__turbopack_context__.v({
  "visualInfo": "VisualInfo-module-scss-module__8_KTkW__visualInfo",
  "visualInfo__dot": "VisualInfo-module-scss-module__8_KTkW__visualInfo__dot",
  "visualInfo__text": "VisualInfo-module-scss-module__8_KTkW__visualInfo__text",
});
